import { TableCell } from "@mui/material"
import type { ColumnRenderDefinition } from "@pharmupp/p3-front-commons"
import {
  AdhJustificationCell,
  AdhParticipationCell,
  AdhStatusCell,
  DividerCell,
  OperationCell,
  PointsCell,
  TypeCell,
} from "../../MarketingOperationsList"
import type { ApiListAdhMarketingOperation } from "../model"

export const marketingOpColumns = {
  type: {
    renderHeader: ({ width }) => <TableCell width={width}>Type</TableCell>,
    renderRow: ({ row }) => <TypeCell {...row} />,
  },
  divider: {
    renderHeader: ({ width }) => <TableCell align="center" width={width} />,
    renderRow: () => <DividerCell />,
  },
  operation: {
    renderHeader: ({ width }) => <TableCell width={width}>Opération</TableCell>,
    renderRow: ({ row }) => (
      <OperationCell
        {...row}
        startDate={row.validityStartDate}
        endDate={row.validityEndDate}
      />
    ),
  },
  points: {
    renderHeader: ({ width }) => <TableCell width={width}>Points</TableCell>,
    renderRow: ({ row }) => <PointsCell {...row} />,
  },
  participation: {
    renderHeader: ({ width }) => <TableCell width={width}>Participation</TableCell>,
    renderRow: ({ row }) => <AdhParticipationCell {...row} />,
  },
  justification: {
    renderHeader: ({ width }) => <TableCell width={width}>Justification</TableCell>,
    renderRow: ({ row }) => <AdhJustificationCell {...row} />,
  },
  status: {
    renderHeader: ({ width }) => (
      <TableCell align="right" width={width}>
        Statut
      </TableCell>
    ),
    renderRow: ({ row }) => <AdhStatusCell {...row} />,
  },
} satisfies Record<string, ColumnRenderDefinition<ApiListAdhMarketingOperation>>
